import axios from "axios";
import {
  incrementGlobalLoading,
  decrementGlobalLoading,
} from "../recoil/loadingController";
import { handleInvalidToken } from "../utils/token";

let isInstalled = false; // 인터셉터 중복 설치 방지
let isHandlingForbidden = false; // 403 처리 단발성 가드 (중복 알림/리다이렉트 방지)

// 전역 403 처리에서 제외할 API 경로 (로그인/재발급 등 비정상 토큰 이슈 아님)
function shouldBypassForbiddenHandling(url) {
  if (!url) return false;
  const excludedPaths = ["/auth/refresh", "/manage/user/login"];
  return excludedPaths.some((path) => url.includes(path));
}

export function setupAxiosLoadingInterceptors() {
  if (isInstalled) return;
  isInstalled = true;

  axios.interceptors.request.use(
    (config) => {
      incrementGlobalLoading(); // 전역 로딩 카운터 증가
      return config;
    },
    (error) => {
      decrementGlobalLoading(); // 전역 로딩 카운터 감소 (에러)
      return Promise.reject(error);
    },
  );

  axios.interceptors.response.use(
    (response) => {
      decrementGlobalLoading(); // 전역 로딩 카운터 감소 (성공)
      return response;
    },
    (error) => {
      decrementGlobalLoading(); // 전역 로딩 카운터 감소 (에러)
      const status = error?.response?.status;
      const url = error?.config?.url;
      // 403 토큰 이슈 전역 처리 (예외 API는 우회)
      if (status === 403 && !shouldBypassForbiddenHandling(url)) {
        if (!isHandlingForbidden) {
          isHandlingForbidden = true; // 한 번만 실행
          handleInvalidToken();
        }
      }
      return Promise.reject(error);
    },
  );
}
